import { render } from "./PartnerCategories.vue?vue&type=template&id=47fd7b1a"
import script from "./PartnerCategories.vue?vue&type=script&lang=js"
export * from "./PartnerCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__